// extracted by mini-css-extract-plugin
export default {"footer":"NotificationDrawer_footer__qMgwh"};